import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable } from 'rxjs';
import { AuthService } from 'my-lib-sanfelici';




@Component({
  selector: 'app-contatti',
  templateUrl: './contatti.component.html',
  styleUrls: ['./contatti.component.css']
})
export class ContattiComponent implements OnInit {
usr: Observable<firebase.User>;
  constructor(
    private authservice: AuthService,
    ) { }

  ngOnInit() {
this.usr = this.authservice.usr;
  }

}
